<style></style>

<template>
    <div id="results-progress-bar" class="mb-4 mt-2" style="width: 50%; position: relative">
        <div class="progress-categories d-flex justify-content-between text-center" style="font-size: .7em">
            <div style="width: 33%; position: relative; left: -16%">Choose Goals</div>
            <div style="width: 33%">Create Plan</div>
            <div  style="width: 33%; position: relative; right: -16%">Take Action</div>
        </div>
        <div class="bar mt-1">
            <div class="progress" :style="{width: width+'%'}"></div>

            <div class="marker-line" style="width: 50%"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            width: {
                default: 0
            }
        }
    
    }
</script>